/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { DocsUrls, FriendliWebsiteUrls } from '@fai/constants/shared-urls';
import i18n from '@fai/friendli-suite/features/i18n';
import Paths from '@fai/friendli-suite/features/routes/paths';

export const docsHeaderLinkProps = {
  path: DocsUrls.Default,
  isOpenInNewTab: true,
  children: i18n.t('auth.docs'),
};

export const pricingHeaderLinkProps = {
  path: FriendliWebsiteUrls.Pricing,
  isOpenInNewTab: true,
  children: i18n.t('auth.pricing'),
};

export const websiteHeaderLinkProps = {
  path: FriendliWebsiteUrls.Default,
  isOpenInNewTab: true,
  children: i18n.t('auth.website'),
};

export const loginHeaderLinkProps = {
  path: Paths.login.default,
  isOpenInNewTab: false,
  children: i18n.t('auth.log_in'),
};
